import Hamburger from "hamburger-react";
import Modal from "../Modal";
import { ShareCartContext } from "../../contexts/ShareCartContext";
import { useContext } from "react";

export default function ShareCartModal() {
  const { shareCartId, setShareCartId } = useContext(ShareCartContext);

  return ModalWrapper(
    "Share Cart",
    !!shareCartId,
    () => setShareCartId(null),
    <div className="max-w-7xl px-6 md:px-12 py-16 max-w-prose bg-secondary">
      <h2 className="t4">Share your cart</h2>
      <p>
        The items in your cart will be copied over when visiting the link below.
      </p>
      <p>
        This link is public and can be shared multiple times. Updates to your
        cart will not be reflected in this link.
      </p>
      <p className="rounded border text-center border-black p-3">
        https://spacetypeco.com/cart/{shareCartId}
      </p>
    </div>
  );
}

const ModalWrapper = (pageName, shouldShow, closeAction, wrapped) => {
  return (
    <Modal
      onClose={() => {
        document.documentElement.setAttribute("data-modal-active", "false");
        closeAction();
      }}
      show={shouldShow}
    >
      <div className="max-w-7xl px-6 md:px-12 py-16 max-w-prose bg-secondary relative rounded">
        {wrapped}
        <div className="absolute right-0 top-0 p-2 md:p-3">
          <Hamburger
            label={`Close ${pageName}`}
            size={20}
            toggled={true}
            toggle={() => {
              document.documentElement.setAttribute(
                "data-modal-active",
                "false"
              );

              closeAction();
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
